import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsMxExtra from '@angular/common/locales/extra/es-MX';
import localeKaExtra from '@angular/common/locales/extra/ka';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeRoExtra from '@angular/common/locales/extra/ro';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localeUkExtra from '@angular/common/locales/extra/uk';
import localeKa from '@angular/common/locales/ka';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeUk from '@angular/common/locales/uk';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MenuUrl } from '@type/menu.type';
import { MenuPermissionsPipe } from './core/permissions/menu-permissions.pipe';
import { AuthService } from './core/services/auth/auth.service';
import { FeatureFlagsService } from './core/services/feature-flags/feature-flags.service';
import { SnowService } from './core/services/snow/snow.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    MatSidenavModule,
    RouterLink,
    MatIconModule,
    RouterLinkActive,
    MatTooltipModule,
    MenuPermissionsPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private auth = inject(AuthService);

  isHealthcheck = window.location.pathname === '/up';

  private snowService = inject(SnowService);

  isSeasonActive = computed(() => this.snowService.isSeasonActive());

  menuShowMode = computed(() => this.snowService.menuShowMode());

  snoopStatus = false;

  menu: MenuUrl[] = [
    { name: '', url: 'companies', icon: 'business', label: 'Companies' },
    { name: 'application-admins', url: 'application-admins', icon: 'people_alt', label: 'Application Admins' },
    { name: 'log', url: 'log', icon: 'list_alt', label: 'Log' },
    { name: 'analytics', url: 'analytics', icon: 'bar_chart', label: 'Analytics' },
  ];

  bottomMenu: { icon: string; route: string | null; exact: boolean; label: string }[] = [
    { icon: 'menu_book', route: 'docs', exact: false, label: 'Documentation' },
    { icon: 'account_circle', route: 'user', exact: true, label: 'User Profile' },
    { icon: 'logout', route: null, exact: true, label: 'Logout' },
  ];

  constructor() {
    const features = inject(FeatureFlagsService);
    (window as any).features = {
      enable: (f: string) => features.enable(f),
      disable: (f: string) => features.disable(f),
      list: () => features.list(),
    };
    this.initLocales();
  }

  logout() {
    this.auth.logout();
  }

  snoopToggle(): void {
    this.snoopStatus = !this.snoopStatus;
  }

  private initLocales() {
    const locales = [
      { code: 'ru', main: localeRu, extra: localeRuExtra },
      { code: 'uk', main: localeUk, extra: localeUkExtra },
      { code: 'ro', main: localeRo, extra: localeRoExtra },
      { code: 'ro-MD', main: localeRo, extra: localeRoExtra },
      { code: 'ro-RO', main: localeRo, extra: localeRoExtra },
      { code: 'es-MX', main: localeEsMx, extra: localeEsMxExtra },
      { code: 'pt-BR', main: localePt, extra: localePt },
      { code: 'ka', main: localeKa, extra: localeKaExtra },
      { code: 'pl', main: localePl, extra: localePlExtra },
    ];

    for (const { code, main, extra } of locales) {
      registerLocaleData(main, code, extra);
    }
  }
}
